
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { eventService } from "../lib/api/event";
import React, { useCallback, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { routes } from "../routes/routes-names";
import moment from "moment";
//@ts-ignore
import Files from 'react-files';
import { ReactFilesFile } from '../types/files';
import { isLessThanTheMB } from '../lib/utils/lessthan-max-filesize';
import { Messages } from '../lib/constants/messages';
import { Modal, Button } from "react-bootstrap";
import { commonService } from "../lib/api/common";
import "../assets/styles/organisation-registration.css";

const CreateEventForm: React.FC = () => {
  const navigate = useNavigate();
  const [programsheet1, setProgramsheet1] = useState<{ file?: File; error?: string } | null>(null);
  const [programsheet2, setProgramsheet2] = useState<{ file?: File; error?: string } | null>(null);
  const [programsheet3, setProgramsheet3] = useState<{ file?: File; error?: string } | null>(null);
  const [programsheet4, setProgramsheet4] = useState<{ file?: File; error?: string } | null>(null);
  const [programsheet5, setProgramsheet5] = useState<{ file?: File; error?: string } | null>(null);
  const [letterHost, setLetterHost] = useState<{ file?: File; error?: string } | null>(null);
  const [showPreview, setShowPreview] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState<{ id: number; dropdownValue: string }[]>([]);
  const [selectedCntry, setSelectedCntry] = useState('');
  const [states, setStates] = useState<{ id: number; dropdownValue: string }[]>([]);
  const [selectedState, setSelectedState] = useState('');
  const [cities, setCities] = useState<{ id: number; dropdownValue: string }[]>([]);

  const [previewFiles, setPreviewFiles] = useState<{ [key: string]: string }>({});
  const [eventCategory, setEventCategory] = useState<{ dropdownCode: string; dropdownValue: string }[]>([]);
  const [eventType, setEventType] = useState<{ dropdownCode: string; dropdownValue: string }[]>([]);
  const [eventDept, setEventDept] = useState<{ dropdownCode: string; dropdownValue: string }[]>([]);





  const initialValues = {
    nameOfEvent: "",
    eventCategory: "",
    eventType: "",
    department: "",
    speciality: "",
    venueAddress: "",
    venueCity: "",
    venueState: "",
    venueCountry: "",
    numberOfPeople: "",
    proposedPoints:"",
    proposed: "",
    startDate: "",
    endDate: "",
    attendancePoints: [], 
    programsheet1: null,
    programsheet2: "",
    programsheet3: "",
    programsheet4: "",
    programsheet5: "",
    letterHost: "",
  };
  const [previewData, setPreviewData] = useState<typeof initialValues | null>(null);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const validationSchema = Yup.object().shape({
    nameOfEvent: Yup.string().required("Required"),
    eventCategory: Yup.mixed().required("Required"),
    eventType: Yup.mixed().required("Required"),
    department: Yup.mixed().required("Required"),
    speciality: Yup.string().required("Required"),
    venueAddress: Yup.string().required("Required"),
    venueCity: Yup.string().required("Required"),
    venueState: Yup.string().required("Required"),
    venueCountry: Yup.string().required("Required"),
    numberOfPeople: Yup.number()
      .transform((value, originalValue) => (originalValue === "" ? undefined : value))
      .typeError("Numbers only")
      .integer("Whole numbers only")
      .min(1, "Must be 1 or more")
      .required("Required"),
    //proposedPoints: Yup.string().required("Required"),
    proposedPoints: Yup.number().typeError("Numbers only").min(0, "Min 0").max(99, "Max 99").test("one-decimal", "Max 1 decimal place", v => v === undefined || Number.isInteger(v) || Number.isInteger(v * 10)).required("Required"),
    startDate: Yup.date()
      .required("Start date is required")
      .min(today, "Start date cannot be in the past"),
    endDate: Yup.date()
      .required("To Date is required")
      .min(Yup.ref("startDate"), "end Date cannot be before From Date"),
    programsheet1: Yup.mixed().required("Required"),
    //programsheet2: Yup.mixed().required("Required"),
    //programsheet3: Yup.mixed().required("Required"),
    //programsheet4: Yup.mixed().required("Required"),
    //programsheet5: Yup.mixed().required("Required"),
    letterHost: Yup.mixed().required("Required"),
    attendancePoints: Yup.array().of(
        Yup.object({
          points: Yup.number()
            .required("Points required")
            .min(0, "Min 0")
            .max(10, "Max 10"),
        })
      ),


  });

  const handlePreview = (values: typeof initialValues) => {
    setPreviewData(values);

    // Create file previews
    const files: { [key: string]: string } = {};
    //if (values.document1) files.document1 = URL.createObjectURL(values.document1);
    //if (values.document2) files.document2 = URL.createObjectURL(values.document2);
    //if (values.document3) files.document3 = URL.createObjectURL(values.document3);
    //setPreviewFiles(files);

    setShowPreview(true);
  };

  const generateAttendanceDays = (start: string, end: string) => {
  const days = [];
  let current = moment(start);
  const last = moment(end);

  while (current <= last) {
    days.push({
      date: current.format("YYYY-MM-DD"),
      points: "",
    });
    current.add(1, "day");
  }
  return days;
};


  const handleFinalSubmit = useCallback(
    async (values: typeof initialValues) => {
      try {
        if (!previewData) return;

        setLoading(true);
        let orgPrimaryId = "";
        const orgData = localStorage.getItem("orgdata");

        if (orgData) {
          const retrievedObject = JSON.parse(orgData);
          orgPrimaryId = retrievedObject.id;
        }
        const [sy, sm, sd] = values.startDate.split("-");
        const [ey, em, ed] = values.endDate.split("-");
        const formattedStartDate = `${sd}-${sm}-${sy}`; // dd-mm-yyyy
        const formattedEndDate = `${ed}-${em}-${ey}`;
        const selectedState = states.find(item => item.id === parseInt(values.venueState));
        const stateName = selectedState?.dropdownValue || "";
        const selectedCountry = countries.find(item => item.id === parseInt(values.venueCountry));
        const countryName = selectedCountry?.dropdownValue || "";
          const eventInfo = {
              ...values,
              attendancePoints: values.attendancePoints,
              venueState:stateName,
              venueCountry:countryName,
              startDate: formattedStartDate,
              endDate: formattedEndDate,
              orgId: orgPrimaryId,
              createdon: moment().format("YYYY-MM-DD"),
              posttime: moment().format("h:mm:ss"),
            };
        const formData = new FormData();
        formData.append("eventInfo", JSON.stringify(eventInfo));
        if (programsheet1?.file) {
          formData.append("programSheet1", programsheet1?.file);
        }
        if (programsheet2?.file) {
          formData.append("programSheet2", programsheet2?.file);
        }
        if (programsheet3?.file) {
          formData.append("programSheet3", programsheet3?.file);
        }
        if (programsheet4?.file) {
          formData.append("programSheet4", programsheet4?.file);
        }
        if (programsheet5?.file) {
          formData.append("programSheet5", programsheet5?.file);
        }
        if (letterHost?.file) {
          formData.append("letterHost", letterHost?.file);
        }
        const { success, data } = await eventService.eventRegistration(formData);
        if (success) {
          setShowPreview(false);
          setLoading(false);
          Swal.fire({
            title: "Success",
            text: "Event  created successfully",
            icon: "success",
            confirmButtonText: "OK",
          }).then(async (result) => {
            if (result.isConfirmed) {
              navigate(routes.userLayout);
            }
          });
        }
      } catch (err) {
        setLoading(false);
        Swal.fire({
          //title: "Error",
          text: "event creation failed",
          icon: "error",
          confirmButtonText: "OK",
        })
        console.log('error in event update', err);
      }
    },
    [programsheet1, programsheet2, programsheet3, programsheet4, programsheet5, letterHost, previewData]
  );

  const getCntryDropDownDetails = useCallback(async () => {
    try {
      const { data } = await commonService.getDropDownValues({ params: { dropDownName: "country" } });
      setCountries(data);
    } catch (err) {
      console.error("dropDown error", err);
    }
  }, []);

  const getEventCategoryDropDownDetails = useCallback(async () => {
    try {
      const { data } = await commonService.getDropDownValues({ params: { dropDownName: "event_category" } });
      setEventCategory(data);
    } catch (err) {
      console.error("dropDown error", err);
    }
  }, []);
  const getEventTypeDropDownDetails = useCallback(async () => {
    try {
      const { data } = await commonService.getDropDownValues({ params: { dropDownName: "event_type" } });
      setEventType(data);
    } catch (err) {
      console.error("dropDown error", err);
    }
  }, []);
  const getEventDeptDropDownDetails = useCallback(async () => {
    try {
      const { data } = await commonService.getDropDownValues({ params: { dropDownName: "event_department" } });
      setEventDept(data);
    } catch (err) {
      console.error("dropDown error", err);
    }
  }, []);
  useEffect(() => {
    getCntryDropDownDetails();
    getEventCategoryDropDownDetails();
    getEventTypeDropDownDetails();
    getEventDeptDropDownDetails();
  }, [getCntryDropDownDetails,getEventCategoryDropDownDetails,getEventDeptDropDownDetails,getEventTypeDropDownDetails]);


  const handleCountryChange = async (countryId: any) => {
    
    const selectedCountry = countries.find(item => item.id === countryId);
    const countryName = selectedCountry?.dropdownValue || "";
    setSelectedCntry(countryName);


    const { success, data } = await commonService.getDropDownValuesByParentId({
      params: { dropDownName: "state", parentId: countryId },
    });

    if (success) {
      setStates(data);
    }
  };


  const handleStateChange = async (stateId: any) => {
    
    const result = states.find(item => item.id === parseInt(stateId));
   const stateName = result?.dropdownValue || "";
    setSelectedState(stateName);
    const { success, data } = await commonService.getDropDownValuesByParentId({
      params: { dropDownName: "city", parentId: stateId },
    });

    if (success) {
      setCities(data);
    }
  };


  return (
    <div className="glass-page event-page">
      <div className="form-card" style={{ width: "100%", maxWidth: 1280 }}>
        <h2 style={{ textAlign: "center", marginBottom: 18, fontWeight: 700 }}>
          Event Creation
        </h2>

        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={handlePreview}
        >

          {({ setFieldValue, values, errors, touched, isSubmitting }) => (
            <Form>
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="org-info-item">Event Name</label>
                  <Field name="nameOfEvent" type="text" className="soft-input" />
                  <div className="text-danger small">
                    <ErrorMessage name="nameOfEvent" />
                  </div>
                </div>
                <div className="col-md-4">
                  <label className="org-info-item">Event Category</label>
                  <Field as="select" name="eventCategory" className="soft-input">
                    <option value="">-- Select Event Category --</option>
                        {eventCategory.map((type) => (
                          <option key={type.dropdownCode} value={type.dropdownValue}>
                            {type.dropdownValue}
                          </option>
                        ))}
                  </Field>
                  <div className="text-danger small">
                    <ErrorMessage name="eventCategory" />
                  </div>
                </div>

                <div className="col-md-4">
                  <label className="org-info-item">Type of the CPD </label>
                  <Field as="select" name="eventType" className="soft-input">
                    <option value="">-- Select Event Type --</option>
                    {eventType.map((type) => (
                          <option key={type.dropdownCode} value={type.dropdownValue}>
                            {type.dropdownValue}
                          </option>
                        ))}

                  </Field>
                  <div className="text-danger small">
                    <ErrorMessage name="eventType" />
                  </div>
                </div>

                  <div className="col-md-4">
                    <label className="org-info-item">Department</label>
                    <Field as="select" name="department" className="soft-input">
                      <option value="">-- Select Department --</option>
                      {eventDept.map((type) => (
                            <option key={type.dropdownCode} value={type.dropdownValue}>
                              {type.dropdownValue}
                            </option>
                          ))}
                    </Field>
                    <div className="text-danger small">
                      <ErrorMessage name="department" />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <label className="org-info-item">Speciality </label>
                    <Field name="speciality" type="text" className="form-control" />
                    <div className="text-danger small">
                      <ErrorMessage name="speciality" />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <label className="org-info-item">Venue Address *</label>
                    <Field name="venueAddress" className="soft-input" />
                    <div className="text-danger small">
                      <ErrorMessage name="venueAddress" />
                    </div>
                  </div>
                </div>

                <div className="row mb-3 pt-3">
                    <div className="col-md-4">
  <label className="org-info-item"> Venue Country *</label>
  <Field name="venueCountry">
    {({ field, form }: any) => (
      <select
        {...field} // Spreads name, value, onBlur, etc.
        className="soft-input"
        onChange={(e) => {
          const countryId = parseInt(e.target.value);
          // 1. Manually update Formik's value for THIS field
          form.setFieldValue("venueCountry", countryId);

          // 2. Reset dependent fields in Formik state
          form.setFieldValue("venueState", "");
          form.setFieldValue("venueCity", "");

          // 3. Clear local state for dependent dropdowns
          setStates([]);
          setCities([]);

          // 4. Trigger any external side effects (e.g., fetching new states)
          handleCountryChange(countryId);
        }}
      >
        <option value="">-- Select Country --</option>
        {countries.map((c) => (
          <option key={c.id} value={c.id}>
            {c.dropdownValue}
          </option>
        ))}
      </select>
    )}
  </Field>
  <div className="text-danger small"><ErrorMessage name="venueCountry" /></div>


                  </div>
                  <div className="col-md-4">
                    <label className="org-info-item">Venue State *</label>
                    <Field name="venueState">
                      {({ field, form }: any) => (
                        <select
                          {...field}
                          className="soft-input"
                          disabled={!states.length}
                          onChange={async (e) => {
                            let stateId = e.target.value;
                            form.setFieldValue("venueState", stateId);
                            form.setFieldValue("venueCity", "");
                            handleStateChange(stateId);
                          }}
                        >
                          <option value="">-- Select State --</option>
                          {states.map((s) => (
                            <option key={s.id} value={s.id}>
                              {s.dropdownValue}
                            </option>
                          ))}
                        </select>
                      )}
                    </Field>
                    <div className="text-danger small"><ErrorMessage name="venueState" /></div>
                  </div>


                  <div className="col-md-4">
                    <label className="org-info-item">Venue District  *</label>
                    <Field as="select" name="venueCity" className="soft-input" disabled={!cities.length}>
                      <option value="">-- Select District  --</option>
                      {cities.map((c) => (
                        <option key={c.id} value={c.dropdownValue}>
                          {c.dropdownValue}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name="venueCity" component="div" className="text-danger" />
                  </div>
                </div>
                <div className="row mb-3 pt-4">
                  <div className="col-md-4 ">
                    <label className="org-info-item">Number of Expected People</label>
                    <Field name="numberOfPeople">
                      {({ field, form }: any) => (
                        <input
                          {...field}
                          type="number"
                          min={1}
                          step={1}
                          className="soft-input"
                          autoComplete="off"
                          onChange={(e) => {
                            const value = e.target.value;

                            // Allow the user to clear the field
                            if (value === "") {
                              form.setFieldValue(field.name, "");
                              return;
                            }

                            const parsed = parseInt(value, 10);
                            if (!Number.isNaN(parsed)) {
                              form.setFieldValue(field.name, parsed);
                            }
                          }}
                        />
                      )}
                    </Field>
                    <div className="text-danger small">
                      <ErrorMessage name="numberOfPeople" />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <label className="org-info-item">Proposed CPD points</label>
                    <Field
                        name="proposedPoints"
                        type="number"
                        className="soft-input"
                        min={0}
                        max={99}
                        step={0.1}
                      />

                    <div className="text-danger small">
                      <ErrorMessage name="proposedPoints" />
                    </div>
                  </div>
                </div>
                {/* From Date */}

                <div className="row p-0">
                  <div className="col-md-4">
                    <label htmlFor="endDate" className="org-info-item fw-bold">
                      Start Date
                    </label>
                    <div className="input-group">
                               <Field
                                  type="date"
                                  name="startDate"
                                  className="soft-input"
                                  onChange={(e: any) => {
                                    setFieldValue("startDate", e.target.value);

                                    if (values.endDate) {
                                      setFieldValue(
                                        "attendancePoints",
                                        generateAttendanceDays(e.target.value, values.endDate)
                                      );
                                    }
                                  }}
                                />

                    </div>
                    <ErrorMessage
                      name="startDate"
                      component="div"
                      className="text-danger small"
                    />
                  </div>

                  {/* To Date */}
                  <div className="col-md-4">
                    <label htmlFor="endDate" className="org-info-item fw-bold">
                      End Date
                    </label>
                    <div className="input-group">
                      <Field
                      type="date"
                      name="endDate"
                      className="soft-input"
                      onChange={(e: any) => {
                        setFieldValue("endDate", e.target.value);

                        if (values.startDate) {
                          setFieldValue(
                            "attendancePoints",
                            generateAttendanceDays(values.startDate, e.target.value)
                          );
                        }
                      }}
                    />

                    </div>
                    <ErrorMessage
                      name="endDate"
                      component="div"
                      className="text-danger small"
                    />
                  </div>
                  {values.attendancePoints.length > 0 && (
                      <div className="card mt-4 p-3">
                        <h5 className="fw-bold mb-3">Attendance Points (Day-wise)</h5>

                        {values.attendancePoints.map((day: any, index: number) => (
                          <div className="row mb-2 align-items-center" key={index}>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="soft-input"
                                value={moment(day.date).format("DD-MM-YYYY")}
                                disabled
                              />
                            </div>

                            <div className="col-md-6">
                              <Field
                                name={`attendancePoints[${index}].points`}
                                type="number"
                                className="soft-input"
                                placeholder="Enter points"
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                  {/* File Uploads */}
                  <div className="row mb-2 mt-4">
                    <div className='text-danger fs-10'>
                      Please upload images pdfs (.jpeg,.png and .pdf) only, with less than 500 KB size.
                    </div>
                    <div className='text-danger fs-10'>
                      File name should not contain any special charaters and should have less than 20 character length.
                    </div>
                  </div>
                  <div className="row mb-2 mt-4 align-items-center justify-content-center">
                    <div className="col-4 mt-3">
                      <div className="drag-img-box d-flex align-items-center justify-content-center">
                        {values.programsheet1 ? (
                          <div className="upload-chip">
                            <div className="upload-icon">
                              <i className="bi bi-paperclip"></i>
                            </div>
                            <div className="upload-meta">
                              <span className="upload-label">Program sheet 1</span>
                              <span className="upload-name">{programsheet1?.file?.name}</span>
                            </div>
                            <button
                              type="button"
                              className="upload-remove"
                              aria-label="Remove Program sheet 1"
                              onClick={() => {
                                setProgramsheet1(null);
                                setFieldValue("programsheet1", null);
                              }}
                            >
                              <i className="bi bi-x-lg"></i>
                            </button>
                          </div>
                        ) : (
                          <Files
                            className="files-dropzone border p-3"
                            onChange={(files: ReactFilesFile[]) => {
                              if (files[0]) {
                                const file = files[0];
                                const isLess = isLessThanTheMB(files[0].size, 0.5);
                                if (isLess) {
                                  setProgramsheet1({ file });
                                  setFieldValue("programsheet1", file.name);
                                }
                                else {
                                  alert(Messages.isLessThanTheMB);
                                }
                              }
                            }}
                            accepts={["application/pdf", "image/*"]}
                            maxFiles={1}
                            clickable
                          >
                              <div className="text-center">
                                <i className="bi bi-file-earmark-arrow-up"></i>
                                <p>
                                  Program sheet 1<span className="text-danger">*</span> </p>
                              </div>
                            </Files>
                        )}
                        {errors.programsheet1 && touched.programsheet1 && (
                          <div className="text-danger">{errors.programsheet1}</div>
                        )}
                      </div>
                    </div>


                    <div className="col-4 mt-3">
                      <div className="drag-img-box d-flex align-items-center justify-content-center">
                        {values.programsheet2 ? (
                          <div className="upload-chip">
                            <div className="upload-icon">
                              <i className="bi bi-paperclip"></i>
                            </div>
                            <div className="upload-meta">
                              <span className="upload-label">Program sheet 2</span>
                              <span className="upload-name">{programsheet2?.file?.name}</span>
                            </div>
                            <button
                              type="button"
                              className="upload-remove"
                              aria-label="Remove Program sheet 2"
                              onClick={() => {
                                setProgramsheet2(null);
                                setFieldValue("programsheet2", null);
                              }}
                            >
                              <i className="bi bi-x-lg"></i>
                            </button>
                          </div>
                        ) : (
                          <Files
                            className="files-dropzone drag-img-box border p-3"
                            onChange={(files: ReactFilesFile[]) => {
                              if (files[0]) {
                                const file = files[0];
                                const isLess = isLessThanTheMB(files[0].size, 0.5);
                                if (isLess) {
                                  setProgramsheet2({ file });
                                  setFieldValue("programsheet2", file.name);
                                }
                                else {
                                  alert(Messages.isLessThanTheMB);
                                }
                              }
                            }}
                            accepts={["application/pdf", "image/*"]}
                            maxFiles={1}
                            clickable
                          >
                              <div className="text-center">
                                <i className="bi bi-file-earmark-arrow-up"></i>
                                <p>Program sheet 2 </p>
                              </div>
                            </Files>


                        )}

                        {errors.programsheet2 && touched.programsheet2 && (
                          <div className="text-danger">{errors.programsheet2}</div>
                        )}

                      </div>
                    </div>
                    <div className="row mb-2 mt-4 align-items-center justify-content-center">
                      <div className="col-4 mt-3">
                        <div className="drag-img-box d-flex align-items-center justify-content-center">

                          {values.programsheet3 ? (
                            <div className="upload-chip">
                              <div className="upload-icon">
                                <i className="bi bi-paperclip"></i>
                              </div>
                              <div className="upload-meta">
                                <span className="upload-label">Program sheet 3</span>
                                <span className="upload-name">{programsheet3?.file?.name}</span>
                              </div>
                              <button
                                type="button"
                                className="upload-remove"
                                aria-label="Remove Program sheet 3"
                                onClick={() => {
                                  setProgramsheet3(null);
                                  setFieldValue("programsheet3", null);
                                }}
                              >
                                <i className="bi bi-x-lg"></i>
                              </button>
                            </div>
                          ) : (
                            <Files
                              className="files-dropzone border p-3"
                              onChange={(files: ReactFilesFile[]) => {
                                if (files[0]) {
                                  const file = files[0];
                                  const isLess = isLessThanTheMB(files[0].size, 0.5);
                                  if (isLess) {
                                    setProgramsheet3({ file });
                                    setFieldValue("programsheet3", file.name);
                                  }
                                  else {
                                    alert(Messages.isLessThanTheMB);
                                  }
                                }
                              }}
                              accepts={["application/pdf", "image/*"]}
                              maxFiles={1}
                              clickable
                            >
                              <div className="text-center">
                                <i className="bi bi-file-earmark-arrow-up"></i>
                                <p>
                                  Program sheet 3 </p>
                              </div>
                            </Files>
                          )}
                          {errors.programsheet3 && touched.programsheet3 && (
                            <div className="text-danger">{errors.programsheet3}</div>
                          )}
                        </div>
                      </div>



                      <div className="col-4 mt-3">
                        <div className="drag-img-box d-flex align-items-center justify-content-center">


                          {values.programsheet4 ? (
                            <div className="upload-chip">
                              <div className="upload-icon">
                                <i className="bi bi-paperclip"></i>
                              </div>
                              <div className="upload-meta">
                                <span className="upload-label">Program sheet 4</span>
                                <span className="upload-name">{programsheet4?.file?.name}</span>
                              </div>
                              <button
                                type="button"
                                className="upload-remove"
                                aria-label="Remove Program sheet 4"
                                onClick={() => {
                                  setProgramsheet4(null);
                                  setFieldValue("programsheet4", null);
                                }}
                              >
                                <i className="bi bi-x-lg"></i>
                              </button>
                            </div>
                          ) : (
                            <Files
                              className="files-dropzone drag-img-box border p-3"
                              onChange={(files: ReactFilesFile[]) => {
                                if (files[0]) {
                                  const file = files[0];
                                  const isLess = isLessThanTheMB(files[0].size, 0.3);
                                  if (isLess) {
                                    setProgramsheet4({ file });
                                    setFieldValue("programsheet4", file.name);
                                  }
                                  else {
                                    alert(Messages.isLessThanTheMB);
                                  }
                                }
                              }}
                              accepts={["application/pdf", "image/*"]}
                              maxFiles={1}
                              clickable
                            >
                              <div className="text-center">
                                <i className="bi bi-file-earmark-arrow-up"></i>
                                <p>Program sheet 4 </p>
                              </div>
                            </Files>
                          )}

                          {errors.programsheet4 && touched.programsheet4 && (
                            <div className="text-danger">{errors.programsheet4}</div>
                          )}

                        </div>
                      </div>
                      <div className="row mb-2 mt-4 align-items-center justify-content-center">
                        <div className="col-4 mt-3">
                          <div className="drag-img-box d-flex align-items-center justify-content-center">

                            {values.programsheet5 ? (
                              <div className="upload-chip">
                                <div className="upload-icon">
                                  <i className="bi bi-paperclip"></i>
                                </div>
                                <div className="upload-meta">
                                  <span className="upload-label">Program sheet 5</span>
                                  <span className="upload-name">{programsheet5?.file?.name}</span>
                                </div>
                                <button
                                  type="button"
                                  className="upload-remove"
                                  aria-label="Remove Program sheet 5"
                                  onClick={() => {
                                    setProgramsheet5(null);
                                    setFieldValue("programsheet5", null);
                                  }}
                                >
                                  <i className="bi bi-x-lg"></i>
                                </button>
                              </div>
                            ) : (
                              <Files
                                className="files-dropzone border p-3"
                                onChange={(files: ReactFilesFile[]) => {
                                  if (files[0]) {
                                    const file = files[0];
                                    const isLess = isLessThanTheMB(files[0].size, 0.5);
                                    if (isLess) {
                                      setProgramsheet5({ file });
                                      setFieldValue("programsheet5", file.name);
                                    }
                                    else {
                                      alert(Messages.isLessThanTheMB);
                                    }
                                  }
                                }}
                                accepts={["application/pdf", "image/*"]}
                                maxFiles={1}
                                clickable
                              >
                                <div className="text-center">
                                  <i className="bi bi-file-earmark-arrow-up"></i>
                                  <p>
                                    Program sheet 5</p>
                                </div>
                              </Files>
                            )}
                            {errors.programsheet5 && touched.programsheet5 && (
                              <div className="text-danger">{errors.programsheet5}</div>
                            )}
                          </div>
                        </div>
                        <div className="col-4 mt-3">
                          <div className="drag-img-box d-flex align-items-center justify-content-center">

                            {values.letterHost ? (
                              <div className="upload-chip">
                                <div className="upload-icon">
                                  <i className="bi bi-paperclip"></i>
                                </div>
                                <div className="upload-meta">
                                  <span className="upload-label">Letter</span>
                                  <span className="upload-name">{letterHost?.file?.name}</span>
                                </div>
                                <button
                                  type="button"
                                  className="upload-remove"
                                  aria-label="Remove Letter"
                                  onClick={() => {
                                    setLetterHost(null);
                                    setFieldValue("letterHost", null);
                                  }}
                                >
                                  <i className="bi bi-x-lg"></i>
                                </button>
                              </div>
                            ) : (
                              <Files
                                className="files-dropzone drag-img-box border p-3"
                                onChange={(files: ReactFilesFile[]) => {
                                  if (files[0]) {
                                    const file = files[0];
                                    const isLess = isLessThanTheMB(files[0].size, 0.5);
                                    if (isLess) {
                                      setLetterHost({ file });
                                      setFieldValue("letterHost", file.name);
                                    }
                                    else {
                                      alert(Messages.isLessThanTheMB);
                                    }
                                  }
                                }}
                                accepts={["application/pdf", "image/*"]}
                                maxFiles={1}
                                clickable
                              >
                                <div className="text-center">
                                  <i className="bi bi-file-earmark-arrow-up"></i>
                                  <p>Letter <span className="text-danger">*</span></p>
                                </div>
                              </Files>

                            )}

                            {errors.letterHost && touched.letterHost && (
                              <div className="text-danger">{errors.letterHost}</div>
                            )}

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  {/* Buttons */}
                  <div className="d-flex justify-content-end mt-3">
                    <button type="submit" className="primary-btn">
                      Submit
                    </button>
                  </div>
                </div>
                {/* Preview Modal */}
                <Modal show={showPreview} onHide={() => setShowPreview(false)} size="lg" centered>
                  <Modal.Header closeButton>
                    <Modal.Title>Preview Event Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {previewData && (
                      <div>
                        <p><strong>Event Name:</strong> {previewData.nameOfEvent}</p>
                        <p><strong>Event Category:</strong> {previewData.eventCategory}</p>
                        <p><strong>EventType:</strong> {previewData.eventType}</p>
                        <p><strong>Event Department:</strong> {previewData.department}</p>
                        <p><strong>Event venue Address:</strong> {previewData.venueAddress}</p>
                        <p><strong>Event City:</strong> {previewData.venueCity}</p>
                        <p><strong>Event State:</strong> {selectedState}</p>
                        <p><strong>Event Country:</strong> {selectedCntry}</p>

                        <p><strong>Event No of People</strong> {previewData.numberOfPeople}</p>
                        <p><strong>Proposed Points</strong>{previewData.proposedPoints}</p>
                        <p><strong>Event start Date:</strong> {previewData.startDate}</p>
                        <p><strong>Event end Date:</strong> {previewData.endDate}</p>

                        <div className="d-flex gap-3">
                          {Object.keys(previewFiles).map((key) => (
                            <div key={key}>
                              <strong>{key}</strong>
                              <img
                                src={previewFiles[key]}
                                alt="Preview"
                                style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                className="border rounded ms-2"
                              />
                            </div>
                          ))}
                        </div>
                        <h6 className="mt-3 fw-bold">Attendance Points</h6>
                        <ul>
                          {previewData.attendancePoints.map((d: any, i: number) => (
                            <li key={i}>
                              {moment(d.date).format("DD-MM-YYYY")} → {d.points} Points
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowPreview(false)}>
                      Edit
                    </Button>
                    <Button variant="success" onClick={() => handleFinalSubmit(values)}>
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2 "
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Submitting in...
                        </>
                      ) : (
                        "Confirm & Submit"
                      )}
                    </Button>
                  </Modal.Footer>
                </Modal>

              </Form>
            )}
          </Formik>
        </div>
      </div>

  );
};

export default CreateEventForm;
